import { type App, computed, type ComputedRef, inject } from 'vue'
import type { CurrencyInput } from '@/graphql/api'
import { type CountryPlugin } from '@/plugins/country.ts'
import { type CurrencyPlugin } from '@/plugins/currency.ts'

const key = 'app.plugin.currency-input'

export function installCurrencyInputPlugin(
    app: App,
    countryPlugin: CountryPlugin,
    currencyPlugin: CurrencyPlugin
): ComputedRef<CurrencyInput> {
    const { countryCode } = countryPlugin
    const { currency } = currencyPlugin

    const input = computed(
        (): CurrencyInput => ({
            country: countryCode.value,
            currency: currency.value,
        })
    )

    app.provide(key, input)

    return input
}

export function useCurrencyInput(): ComputedRef<CurrencyInput> {
    return inject(key) as ComputedRef<CurrencyInput>
}
